import { useEffect } from "react";
import { ShippingDetailsViewModel } from "../../viewmodels/shipping/ShippingDetailsViewModel";

import { useParams } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";
import CreateNewShippingForm from "../../components/forms/shipping/CreateNewShippingForm";
import AuditActionLink from "../../components/audit/AuditActionLink";
import OperationalDataTableSkeleton from "../../components/operational/OperationalDataTableSkeleton";
import FormSectionLoadingSkeleton from "../../components/operational/FormSectionLoadingSkeleton";
import {
  USER_DEPARTMENT_CODE,
  USER_TYPE_CODE,
} from "../../shared/userReferenceCodes";

function formatCustomerHeading(customer) {
  if (customer == null || customer === "") return null;
  if (typeof customer === "string") return customer;
  if (typeof customer === "object") {
    return customer.name ?? customer.label ?? null;
  }
  return null;
}

function ShippingDetails(props) {
  const { addSnackbar, logout, user_type } = props;

  const { shippingId } = useParams();

  const {
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    emptyModal,
    showErrorModal,
    updateShippingApiCall,
    shipping,
    addPackagedItemToOrderItem,
    getShippingDetails,
    loading,
    removeShippedCartonApiCall,
    employeeOptions,
    getUsersForDropdown,
    deleteShipping,
    printShipping,
    isPrintingShipping,
    getOrderItemShipments,
    createShippingRecordByID,
    setProductTemperature,
    onFetchPackagedItemByBarcode,
    generateAndPrintShippingLabel,
    shippingLabelEnabled,
    onCreatePriceSplit,
    onUpdatePriceSplit,
    onDeletePriceSplit,
    invalidOrderItemIds,
    quickBooksInvoice,
  } = ShippingDetailsViewModel(shippingId, logout, addSnackbar);

  const apiFunctionCalls = function () {
    getShippingDetails();
    getUsersForDropdown(
      [USER_TYPE_CODE.REGULAR, USER_TYPE_CODE.SUPERVISOR],
      [USER_DEPARTMENT_CODE.ALL, USER_DEPARTMENT_CODE.SHIPPING],
    );
  };

  useEffect(() => {
    apiFunctionCalls();
  }, []);

  const customerHeadingLine = shipping
    ? formatCustomerHeading(shipping.customer)
    : null;

  return (
    <div className="qatrace-screen qatrace-module-page">
      <div className="mt-2 pl-0 sm:px-4">
        <div className="sm:items-center">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div className="sm:flex-auto">
              {loading && !shipping ? (
                <FormSectionLoadingSkeleton rows={2} className="max-w-md" />
              ) : (
                <>
                  <h1 className="text-xl font-semibold leading-6 text-gray-900">
                    {shipping?.shipping_number
                      ? `${shipping.shipping_number} · PO #: ${shipping?.po_number ?? ""}`
                      : `Shipment PO #: ${shipping?.po_number ?? ""}`}
                  </h1>
                  {customerHeadingLine ? (
                    <p className="mt-1 text-lg text-gray-600">
                      {customerHeadingLine}
                    </p>
                  ) : null}
                </>
              )}
            </div>
            {shipping ? (
              <AuditActionLink
                slug="shipment"
                id={shipping.id}
                name={
                  shipping.shipping_number ??
                  shipping.invoice_number ??
                  `SHIP-${shipping.id}`
                }
              />
            ) : null}
          </div>
          <div className="mt-5">
            {shipping ? (
              <>
                <CreateNewShippingForm
                  setEmptyModelOpen={setEmptyModelOpen}
                  showErrorModal={showErrorModal}
                  updateShippingApiCall={updateShippingApiCall}
                  shipping={shipping}
                  onFetchPackagedItemByBarcode={onFetchPackagedItemByBarcode}
                  addPackagedItemToOrderItem={addPackagedItemToOrderItem}
                  removeShippedCartonApiCall={removeShippedCartonApiCall}
                  employeeOptions={employeeOptions}
                  deleteShipping={deleteShipping}
                  printShipping={printShipping}
                  isPrintingShipping={isPrintingShipping}
                  getOrderItemShipments={getOrderItemShipments}
                  createShippingRecordByID={createShippingRecordByID}
                  setProductTemperature={setProductTemperature}
                  user_type={user_type}
                  generateAndPrintShippingLabel={
                    shippingLabelEnabled
                      ? generateAndPrintShippingLabel
                      : undefined
                  }
                  onCreatePriceSplit={onCreatePriceSplit}
                  onUpdatePriceSplit={onUpdatePriceSplit}
                  onDeletePriceSplit={onDeletePriceSplit}
                  invalidOrderItemIds={invalidOrderItemIds}
                  quickBooksInvoice={quickBooksInvoice}
                />
              </>
            ) : loading ? (
              <div className="space-y-5">
                <div className="rounded-[18px] border border-[#E2E8F0] bg-white p-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)] sm:p-6">
                  <FormSectionLoadingSkeleton rows={4} />
                </div>
                <div className="rounded-[18px] border border-[#E2E8F0] bg-white p-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)] sm:p-6">
                  <OperationalDataTableSkeleton
                    columns={[
                      "Product",
                      "Order quantity/Cs",
                      "Shipped quantity",
                      "Product condition",
                      "Product Temperature",
                      "Actions",
                    ]}
                    rows={5}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass="max-w-3xl"
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user_type: state.auth.user_type,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShippingDetails),
);
